import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const ContactSection = ({ language }) => {
  const content = {
    en: {
      title: 'Visit Our Store',
      subtitle: 'We are located in the heart of Jamkhambhalia',
      address: 'Jodhpur Naka, Bhavani Sadi Same, Shyam Kekora Mart Bajuma, Jamkhambhalia',
      phone: 'Phone',
      timing: 'Store Hours',
      hours: 'Monday - Sunday: 8:00 AM - Closing',
      mapButton: 'Get Directions'
    },
    gu: {
      title: 'અમારા સ્ટોરની મુલાકાત લો',
      subtitle: 'અમે જામખંબાળીયાના મધ્યમાં સ્થિત છીએ',
      address: 'જોધપુર નાકા, ભવાની સાડી સામે, શ્યામ કેકોરા માર્ટની બાજુમાં, જામખંબાળીયા',
      phone: 'ફોન',
      timing: 'સ્ટોર સમય',
      hours: 'સોમવાર - રવિવાર: સવારે 8:00 થી બંધ સુધી',
      mapButton: 'દિશાઓ મેળવો'
    }
  };

  const t = content[language];

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-xl text-gray-600">{t.subtitle}</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <Card className="hover:shadow-xl transition-shadow duration-300 border-2 hover:border-red-400">
            <CardContent className="p-6 text-center">
              <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{language === 'en' ? 'Address' : 'સરનામું'}</h3>
              <p className="text-gray-600 leading-relaxed">{t.address}</p>
            </CardContent>
          </Card>
          
          <Card className="hover:shadow-xl transition-shadow duration-300 border-2 hover:border-red-400">
            <CardContent className="p-6 text-center">
              <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t.phone}</h3>
              <a href="tel:+919924086184" className="block text-red-600 hover:text-red-700 font-semibold mb-2">+91 99240 86184</a>
              <a href="tel:+917096705611" className="block text-red-600 hover:text-red-700 font-semibold">+91 70967 05611</a>
            </CardContent>
          </Card>
          
          <Card className="hover:shadow-xl transition-shadow duration-300 border-2 hover:border-red-400">
            <CardContent className="p-6 text-center">
              <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t.timing}</h3>
              <p className="text-gray-600">{t.hours}</p>
            </CardContent>
          </Card>
        </div>
        
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Jodhpur+Naka+Jamkhambhalia"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            <MapPin className="inline-block mr-2 h-5 w-5" />
            {t.mapButton}
          </a>
        </div>
      </div>
    </section>
  );
};